import { useMemo } from 'react';

import { Select, SelectItem } from '@braskai/ui-kit';

import { Box } from '@mui/material';

import { IS_ENV_SELECTOR } from '@/app/config';

import { APP_ENV, AppEnv, CURRENT_ENV, IS_LOCAL_BUILD, setAppEnv } from '@/shared/environments';

const LABEL_MAP: { [k in string]: string } = {
  [APP_ENV.prod]: '🟢 Prod',
  [APP_ENV.qa]: '⚪ QA',
  [APP_ENV.stg]: '🟡 Stg',
  [APP_ENV.tst]: '⚪ Tst',
};

const LOCAL_ENV = '⚙️ Local';

// visible only in development MODE
export const ServerEnvSelector = () => {
  const onSelectEnv = (env: AppEnv) => {
    setAppEnv(env);
    window.location.reload();
  };

  const options = useMemo(() => {
    const tmp = Object.keys(APP_ENV).map((item) => (
      <SelectItem key={item} value={item}>
        {LABEL_MAP[item]}
      </SelectItem>
    ));

    if (IS_LOCAL_BUILD) {
      tmp.push(
        <SelectItem key="local" value="">
          {LOCAL_ENV}
        </SelectItem>,
      );
    }

    return tmp;
  }, []);

  // TODO change on IS_PRODUCTION_BUILD, local build for first iteration
  if (!IS_LOCAL_BUILD || !IS_ENV_SELECTOR) {
    return null;
  }

  return (
    <Box sx={{ bottom: 14, opacity: 0.5, position: 'fixed', right: 76, zIndex: 2 }}>
      <Select
        renderValue={() => LABEL_MAP[CURRENT_ENV] || LOCAL_ENV}
        size="small"
        style={{ position: 'relative' }}
        value={CURRENT_ENV}
        onChange={(e) => onSelectEnv(e.target.value as AppEnv)}
      >
        {options}
      </Select>
    </Box>
  );
};
